module.exports = __webpack_public_path__ + "img/t5-i7.fee707b8.svg";